<div class="relative cardWithShadow">
  <div (click)="close()" class="z-10 absolute w-8 aspect-square flex justify-center items-center rounded cursor-pointer right-4 top-4 hover:bg-[var(--mat-color-light-table-hover)] hover:text-[var(--mat-sys-primary)]">
    <i-tabler name="x" />
  </div>
  <app-tab class="[&_.mat-mdc-tab-body-content>div]:!p-0 [&_.mat-mdc-tab-label-container]:border-transparent!" [tabs]="tabs"></app-tab>
</div>
